export { DeviceFrame } from './DeviceFrame';
export { DeviceFrameMobile } from './DeviceFrameMobile';
export { DeviceFrameTablet } from './DeviceFrameTablet';
export { DeviceFrameDesktop } from './DeviceFrameDesktop';